// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OKeZ7","type":"styles_type__q9teM","choices":"styles_choices__3froL"};